import { Action } from "@ngrx/store";
import { Financiadores } from "../../models/financiadores.model";

export const SET_FINANCIADOR = '[financiadores] Set Financiador';
export const UNSET_FINANCIADOR = '[financiadores] Unset Financiador';
export const UPDATE_FINANCIADORES = '[financiadores] Update Financiadores';

export class SetFinanciador implements Action {
    readonly type = SET_FINANCIADOR;
    constructor(public financiadorSeteado: Financiadores) { }
}

export class UnsetFinanciador implements Action {
    readonly type = UNSET_FINANCIADOR;
}

export class UpdateFinanciadores implements Action {
    readonly type = UPDATE_FINANCIADORES;
    constructor(public financiadorActualizado: Financiadores) { }
}

export type FinanciadoresActions = SetFinanciador | UnsetFinanciador | UpdateFinanciadores;